class RadioChange{
  constructor(radios, id = '', idName = 'id') {
    this.radios = radios
    this.idName = idName
    this.init(id)
  }
  choose(id) {
    const index = this.radios.findIndex(item => item[this.idName] === id)
    if (!this.radios[index].canBeUse) return
    this.radios = this.radios.map(item => {
      if (id === item[this.idName]) {
        return {
          ...item,
          isChange: !item.isChange
        }
      }
      return {
        ...item,
        isChange: item.isChange
      }
    })
  }
  setAuthToNo (id, canBeUse = false) {
    const index = this.radios.findIndex(item => item[this.idName] === id)
    this.radios = this.radios.map((item, i) => {
      if (index === i) {
        return {
          ...item,
          canBeUse
        }
      }
      return item
    })
  }
  init (id) {
    this.radios = this.radios.map(item => {
      if (id === item[this.idName]) {
        return {
          ...item,
          canBeUse: true,
          isChange: true
        }
      }
      return {
        ...item,
        canBeUse: true,
        isChange: false
      }
    })
  }
  change (id){
    const index = this.radios.findIndex(item => item[this.idName] === id)
    if (!this.radios[index].canBeUse) return
    this.radios = this.radios.map(item => {
      if (id === item[this.idName]) {
        return {
          ...item,
          isChange: true
        }
      }
      return {
        ...item,
        isChange: false
      }
    })
  }
  get getRadios () {
    return this.radios
  }
  get isChoose () {
    return this.radios.every(item => !item.isChange)
  }
}

export default RadioChange